import * as OurLocationsFeaturesForPageUploads from "$lib/data/generated/uploads/our locations/Features For Page/uploads.js";
import * as OurLocationsFeaturesForPageLocationServicesUploads from "$lib/data/generated/uploads/our locations/Features For Page Location Services/uploads.js";
import * as OurLocationsFeaturesLocationGridUploads from "$lib/data/generated/uploads/our locations/Features Location Grid/uploads.js";
import * as OurLocationsHeadUploads from "$lib/data/generated/uploads/our locations/Head/uploads.js";
import * as OurLocationsHeadForLocationPageUploads from "$lib/data/generated/uploads/our locations/Head For Location Page/uploads.js";
import * as OurLocationsLocationPageUploads from "$lib/data/generated/uploads/our locations/LocationPage/uploads.js";
import * as OurLocationsLocations01Uploads from "$lib/data/generated/uploads/our locations/Locations 01/uploads.js";
import * as OurLocationsPageBannerUploads from "$lib/data/generated/uploads/our locations/PageBanner/uploads.js";
import * as OurLocationsPageBannerForLocationPageUploads from "$lib/data/generated/uploads/our locations/PageBanner For Location Page/uploads.js";

export const uploads = {
  ...OurLocationsFeaturesForPageUploads.uploads,
  ...OurLocationsFeaturesForPageLocationServicesUploads.uploads,
  ...OurLocationsFeaturesLocationGridUploads.uploads,
  ...OurLocationsHeadUploads.uploads,
  ...OurLocationsHeadForLocationPageUploads.uploads,
  ...OurLocationsLocationPageUploads.uploads,
  ...OurLocationsLocations01Uploads.uploads,
  ...OurLocationsPageBannerUploads.uploads,
  ...OurLocationsPageBannerForLocationPageUploads.uploads
};
